import {Injectable} from '@angular/core';
import {AppUpdate, AppUpdateAvailability} from '@capawesome/capacitor-app-update';
import {Capacitor} from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class VersionService {
    constructor() {
    }

    async getCurrentAppVersion() {
        const result = await AppUpdate.getAppUpdateInfo();
        if (Capacitor.getPlatform() === 'android') {
            return result.currentVersionCode;
        } else {
            return result.currentVersionName;
        }
    }

    async getAvailableAppVersion() {
        const result = await AppUpdate.getAppUpdateInfo();
        if (Capacitor.getPlatform() === 'android') {
            return result.availableVersionCode;
        } else {
            return result.availableVersionName;
        }
    }

    async openAppStore() {
        await AppUpdate.openAppStore();
    }

    async performImmediateUpdate() {
        const result = await AppUpdate.getAppUpdateInfo();
        if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) {
            return;
        }
        if (result.immediateUpdateAllowed) {
            await AppUpdate.performImmediateUpdate();
        }
    }
}
